import 'babel-polyfill'
import 'bluebird'
import Vue from 'vue'
import ViewUI from 'view-design'
import Modal from './libs/modal/index'
import GlobalDrawerPlugin from './libs/drawer/GlobalDrawerPlugin';
import { router } from './router/index'
import { appRouter } from './router/router'
import store from './store'
import App from './app.vue'
import './theme/index.less'
import dataV from './libs/datav.min.vue'
import VueBus from 'vue-bus'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Print from 'vue-print-nb'

import pinyin from 'js-pinyin'
Vue.use(Print)
Vue.use(ElementUI);
Vue.use(dataV)
Vue.use(VueBus)
// Vue全局配置
Vue.config.silent = true
Vue.use(ViewUI, {
  transfer: true,
  size: 'default',
})
// 注册全局Drawer插槽组件
Vue.use(GlobalDrawerPlugin);
// 注册全局组件
import './views/components/common'
// 工具
import './utils'
// 表单方法
import './views/components/func/form'
import timer from "@/utils/timer";
// 注册modal组件-覆盖原view-design的modal组件
Vue.prototype.$Modal = Modal

timer(Vue.prototype.$bus);
// 自定义权限指令，显示可操作组件
Vue.directive('auth', {
  bind: function (el, binding, vnode) {
    // console.log(el, binding, 122334);

    // 用户权限表
    const rules = $utils.data.get('auth', 'auths') || []
    for (let i = 0; i < rules.length; i++) {
      const item = rules[i]
      // 空放行
      if (!binding.value) {
        return true
      }
      if (binding.value && binding.value == item.url) {
        // 放行 显示组件
        return true
      }
    }
    // 移除组件
    if (el) {
      el.style.display = 'inline-block'
    }
    if (el.parentNode) {
      el.parentNode.removeChild(el)
    }
  },
})

Vue.directive('authTwo', {
  inserted: function (el, binding, vnode) {
    // 用户权限表
    const rules = $utils.data.get('auth', 'auths') || []
    if (!binding.value) return;
    const hasAccess = rules.some(item => binding.value === item.url);
    // 移除组件
    if (!hasAccess) {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      } else{
        console.log("父节点不存在，无法移除元素。");
      }
    }
  },
})



new Vue({
  el: '#app',
  router: router,
  store: store,
  render: (h) => h(App),
  data: {
    currentPageName: '',
  },
  mounted() {
    this.currentPageName = this.$route.name
    // 显示打开的页面的列表
    // this.$store.commit('setOpenedList');
    // this.$store.commit('initCachepage');
    // 权限菜单过滤相关
    this.$store.commit('updateMenulist')
  },
  created() {
    // let tagsList = [];
    // appRouter.map((item) => {
    //     if (item.children.length <= 1) {
    //         tagsList.push(item.children[0]);
    //     } else {
    //         tagsList.push(...item.children);
    //     }
    // });
    // this.$store.commit('setTagsList', tagsList);
  },



})
// export const eventBus = new Vue();
